import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { JsonApiError } from 'json-api';
import { Observable } from 'rxjs';

@Component({
  selector: 'atm-error-dialog',
  templateUrl: './error-dialog.component.html',
  styleUrls: ['./error-dialog.component.scss'],
})
export class ErrorDialogComponent {
  details = false;
  detailsData =
    this.data.code === '45' ? JSON.parse(this.data.detail!) : this.data.detail;
  copySucceed = false;
  timer$ = Observable;
  timer = setTimeout(() => {
    this.dialogRef.close();
  }, 5000);
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: JsonApiError,
    public dialog: MatDialog,
    private dialogRef: MatDialogRef<ErrorDialogComponent>
  ) {}

  showDetails(): void {
    this.details = !this.details;
    clearTimeout(this.timer);
  }

  copied($event: boolean) {
    this.copySucceed = $event;
  }
}
